// populateData.js
const populateData = (rawData = {}) => {
    
    const dateFields = [
      'dob',
      'co_borrower_dob',
      'employer_since',
      'co_borrower_employer_since',
      'address_since',
      'drivers_license_issue_date',
      'drivers_license_expire_date',
      'co_borrower_drivers_license_issue_date',
      'co_borrower_drivers_license_expire_date',
      'co_borrower_address_since',
      'next_payment_date',
      'past_movein_date',
      'past_moveout_date',
      'past_hire_date',
      'past_last_day_of_employment_date',
      'co_borrower_past_hire_date',
      'co_borrower_past_last_day_of_employment_date',
      'co_borrower_past_movein_date',
      'co_borrower_past_moveout_date',
    ];
    
    const formData = {
      // Personal Information
      first_name: rawData.first_name || '',
      last_name: rawData.last_name || '',
      email: rawData.email || '',
      phone_1: rawData.phone_1 || '',
      dob: rawData.dob || null,
      marital_status: rawData.marital_status || '',
      license_no: rawData.license_no || '',
      drivers_license_type: rawData.drivers_license_type || '',
      drivers_license_issue_date: rawData.drivers_license_issue_date || null,
      drivers_license_expire_date: rawData.drivers_license_expire_date || null,
      license_state: rawData.license_state || '',
      ssn: rawData.ssn || '',
      ssn_confirm: rawData.ssn_confirm || '',
  
      // Current Address
      address_1: rawData.address_1 || '',
      address_2: rawData.address_2 || '',
      city: rawData.city || '',
      state: rawData.state || '',
      zip: rawData.zip || '',
      address_since: rawData.address_since || null,
  
      // Past Address
      past_address_1: rawData.past_address_1 || '',
      past_address_2: rawData.past_address_2 || '',
      past_city: rawData.past_city || '',
      past_state: rawData.past_state || '',
      past_zip: rawData.past_zip || '',
      past_movein_date: rawData.past_movein_date || null,
      past_moveout_date: rawData.past_moveout_date || null,
  
      // Employment
      employer: rawData.employer || '',
      employment_status: rawData.employment_status || '',
      employer_since: rawData.employer_since || null,
      job_title: rawData.job_title || '',
      employer_phone_1: rawData.employer_phone_1 || '',
      employer_address_1: rawData.employer_address_1 || '',
      employer_city: rawData.employer_city || '',
      employer_state: rawData.employer_state || '',
      employer_zip: rawData.employer_zip || '',
      past_employer: rawData.past_employer || '',
      past_occupation: rawData.past_occupation || '',
      past_hire_date: rawData.past_hire_date || null,
      past_last_day_of_employment_date: rawData.past_last_day_of_employment_date || null,
  
      // Co-Borrower
      coapplicant: rawData.coapplicant || 'No',
      co_borrower_relationship: rawData.co_borrower_relationship || '',
      co_borrower_first_name: rawData.co_borrower_first_name || '',
      co_borrower_last_name: rawData.co_borrower_last_name || '',
      co_borrower_phone_1: rawData.co_borrower_phone_1 || '',
      co_borrower_email: rawData.co_borrower_email || '',
      co_borrower_dob: rawData.co_borrower_dob || null,
      co_borrower_marital_status: rawData.co_borrower_marital_status || '',
      co_borrower_license_no : rawData.co_borrower_license_no || '',
      co_borrower_drivers_license_type: rawData.co_borrower_drivers_license_type || '',
      co_borrower_drivers_license_issue_date: rawData.co_borrower_drivers_license_issue_date || null,
      co_borrower_drivers_license_expire_date: rawData.co_borrower_drivers_license_expire_date || null,
      co_borrower_license_state: rawData.co_borrower_license_state || '',
      co_borrower_ssn: rawData.co_borrower_ssn || '',
      co_borrower_ssn_confirm: rawData.co_borrower_ssn || '',
  
      // Co-Borrower Employment
      co_borrower_employment_status: rawData.co_borrower_employment_status || '',
      co_borrower_employer: rawData.co_borrower_employer || '',
      co_borrower_employer_since: rawData.co_borrower_employer_since || null,
      co_borrower_past_employer: rawData.co_borrower_past_employer || '',
      co_borrower_past_occupation: rawData.co_borrower_past_occupation || '',
      co_borrower_past_hire_date: rawData.co_borrower_past_hire_date || null,
      co_borrower_past_last_day_of_employment_date: rawData.co_borrower_past_last_day_of_employment_date || null,

      co_borrower_job_title: rawData.co_borrower_job_title || '',
      co_borrower_employer_phone_1: rawData.co_borrower_employer_phone_1 || '',
      co_borrower_employer_address_1: rawData.co_borrower_employer_address_1 || '',
      co_borrower_employer_city: rawData.co_borrower_employer_city || '',
      co_borrower_employer_state: rawData.co_borrower_employer_state || '',
      co_borrower_employer_zip: rawData.co_borrower_employer_zip || '',
  
      // Co-Borrower Address
      co_borrower_address_1: rawData.co_borrower_address_1 || '',
      co_borrower_address_2: rawData.co_borrower_address_2 || '',
      co_borrower_city: rawData.co_borrower_city || '',
      co_borrower_state: rawData.co_borrower_state || '',
      co_borrower_zip: rawData.co_borrower_zip || '',
      co_borrower_address_since: rawData.co_borrower_address_since || null,
      co_borrower_past_address_1: rawData.co_borrower_past_address_1 || '',
      co_borrower_past_address_2: rawData.co_borrower_past_address_2 || '',
      co_borrower_past_city: rawData.co_borrower_past_city || '',
      co_borrower_past_state: rawData.co_borrower_past_state || '',
      co_borrower_past_zip: rawData.co_borrower_past_zip || '',
      co_borrower_past_movein_date: rawData.co_borrower_past_movein_date || null,
      co_borrower_past_moveout_date: rawData.co_borrower_past_moveout_date || null,

      co_borrower_rent_own: rawData.co_borrower_rent_own || '',
      co_borrower_gross_income: rawData.co_borrower_gross_income || '',
      co_borrower_monthly_home_payment: rawData.co_borrower_monthly_home_payment || '',
      // Financials
      rent_own: rawData.rent_own || '',
      monthly_home_payment: rawData.monthly_home_payment || '',
      other_expenses: rawData.other_expenses || '',
      monthly_income: rawData.monthly_income || '',
      
      // Vehicle
      vin: rawData.vin || '',
      make: rawData.make || '',
      model: rawData.model || '',
      model_year: rawData.model_year || '',
      mileage: rawData.mileage || '',
      current_monthly_payment: rawData.current_monthly_payment || '',
      current_payoff: rawData.current_payoff || '',
      next_payment_date: rawData.next_payment_date || null,
      lien_holder: rawData.lien_holder || '',
  
      // Equity (if applicable)
      equity_type: rawData.equity_type || '',
      property_type: rawData.property_type || '',
      loan_reason: rawData.loan_reason || '',
      amount_requested: rawData.amount_requested || '',
      loan_terms: rawData.loan_terms || '',
      estimated_property_value: rawData.estimated_property_value || '',
      intended_occupy_property: rawData.intended_occupy_property || '',
      second_mortgage: rawData.second_mortgage || '',
      monthly_hazard_insurance: rawData.monthly_hazard_insurance || '',
      monthly_real_estate_taxes: rawData.monthly_real_estate_taxes || '',
      monthly_mortgage_insurance: rawData.monthly_mortgage_insurance || '',
      monthly_homeowner_assn_dues: rawData.monthly_homeowner_assn_dues || '',
      social_security_income: rawData.social_security_income || '',
      // Miscellaneous
      comments: rawData.comments || '',
      lang: rawData.lang || '',
      promo_code: rawData.promo_code || '',
      fi_or_refi: rawData.fi_or_refi || '',
      call_schedule: rawData.call_schedule || '',
    };
  
    return formData;
  };
  
  export default populateData;